export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false
  const mm = window.matchMedia?.bind(window)
  if (mm?.('(display-mode: standalone)').matches) return true
  if (mm?.('(display-mode: fullscreen)').matches) return true
  return (navigator as { standalone?: boolean }).standalone === true
}

export function webAuthnAvailable(): boolean {
  if (typeof window === 'undefined') return false
  if (!window.isSecureContext) return false
  if (!('credentials' in navigator) || typeof PublicKeyCredential === 'undefined') return false
  const host = window.location.hostname
  if (!host) return false
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false
  return true
}
